var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_fUwJ4omFjjinI0pBc336elm3xON4NjXF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_fUwJ4omFjjinI0pBc336elm3xON4NjXF)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 16.692 17.792 C 17.36 16.631 18.644 15.946 19.39 14.919 C 20.18 13.841 19.738 11.827 17.499 11.827 C 16.033 11.827 15.312 12.897 15.009 13.782 L 12.762 12.872 C 13.378 11.092 15.052 9.563 17.49 9.563 C 19.529 9.563 20.926 10.457 21.638 11.577 C 22.245 12.538 22.601 14.334 21.664 15.67 C 20.623 17.149 19.625 17.6 19.087 18.553 C 18.87 18.937 18.783 19.188 18.783 20.424 L 16.276 20.424 C 16.267 19.772 16.163 18.711 16.692 17.792 Z  M 19.234 23.766 C 19.234 24.685 18.453 25.437 17.499 25.437 C 16.545 25.437 15.764 24.685 15.764 23.766 C 15.764 22.847 16.545 22.095 17.499 22.095 C 18.453 22.095 19.234 22.847 19.234 23.766 Z ",
    fill: "rgb(255,255,255)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.a693ba63a33229d3261ddbc979706a56.svg";
export { ForwardRef as ReactComponent };